/**
 * Determines if a value should be displayed in the UI.
 * Returns false only for: null, undefined, empty string (after trim)
 * Returns true for: 0, false, empty arrays, other values
 */
export function hasValue(value: unknown): boolean {
  if (value === null || value === undefined) return false;
  if (typeof value === 'string' && value.trim() === '') return false;
  return true;
}
